/* =============================================================================
   TPP STICKY ADD-TO-CART  —  winning variant from the Intelligems A/B test.

   Ported from the Intelligems experiment into the theme so the winner survives
   after Intelligems is disabled. Behaviour is unchanged from the tested variant.

   v2 — robustness fixes:
     • Runs on EVERY product page (any /products/… URL).
     • Survives flavour switches, whether they hard-reload or swap via AJAX,
       plus browser back/forward and bfcache restores.
     • Always re-binds to the CURRENT page's real Add-to-Cart button and mirrors
       the shopper's live selection (size / one-time vs subscription / price).
     • Clicks the real ATC button, so the selected selling plan flows through.
     • Shows a loading spinner on the sticky button while the add-to-cart processes.

   COLOURS:  bar #692D01 (brown) · text #FCC9BD (peach) · button #FCC9BD on #692D01.
   Self-contained (injects its own CSS). To use the Styles tab instead, lift the
   block inside injectCSS() across.
   ============================================================================= */

(function () {
  'use strict';

  if (window.__tppStickyATCLoaded) return;     // patch history + listeners ONCE
  window.__tppStickyATCLoaded = true;

  /* ---------------------------- CONFIG ------------------------------------- *
   * Verify the ATC selector against the live PDP (Inspect the real button).   */
  var CONFIG = {
    atcSelectors: [
      '.pdp-atc-btn'                            // the real buy-box button on this theme (verified live)
    ],                                         // NB: do NOT add a generic '/cart/add button[type=submit]'
                                               // selector — this PDP has upsell "+ Add" forms that match first.
    atcTextMatch: /add to cart/i,              // text fallback; only the real button reads "ADD TO CART …"
    glass: {                                   // frosted glass — copied from .header__wrapper (.is-scrolled) on the live site
      tint: '247,237,219',                     // cream #f7eddb (the header's glass tint)
      opacity: 0.6,                            // header uses rgba(247,237,219,0.6)
      fallbackOpacity: 0.85,                   // more opaque when backdrop-filter is unsupported (keeps text legible)
      blur: '14px',                            // header: blur(14px)
      saturate: '1.8',                         // header: saturate(1.8)
      border: '0',                             // header has no border; separation comes from the shadow below
      shadow: '0 -1px 0 0 rgba(189,105,48,.12), 0 -8px 22px rgba(0,0,0,.08)'
    },
    uspColor:     '#692D01',                   // brown for the USP icons + labels (legible on cream glass)
    usps: [                                    // two trust badges under the button (icon + label)
      { label: 'Rated 4.9/5',
        icon: '<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>' },
      { label: '30-Day Money Back Guarantee',
        icon: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2.5"/><path d="M6 9.5h.01M18 14.5h.01"/></svg>' }
    ],
    // Compare-at price: read the struck <s> from the SELECTED purchase-option card,
    // scoped to the buy box so the Rebuy upsell compare-at prices are never picked up.
    compareAtOption: '.pdp-frequency-option',
    compareAtStruck: 's',
    onlyOnProductPages: true,
    // Mobile-only. The Intelligems experiment this was ported from targeted
    // `device equals mobile`, so desktop never saw the tested variant and there is no
    // evidence it helps there. Bar shows at viewports <= this width, hidden above it.
    // Impact's desktop breakpoint is 1000px, so 999 keeps phones AND tablets in.
    // Drop to 699 to restrict it to phones only.
    mobileMaxWidth: 999,
    zIndex: 2147483000
  };
  /* ------------------------------------------------------------------------- */

  var state = { bar: null, btn: null, btnLabel: null, realATC: null, mo: null, loading: false };
  // Shared so withObserverPaused() can re-attach on exactly the same terms.
  var MO_OPTIONS = { childList: true, subtree: true, characterData: true,
                     attributes: true, attributeFilter: ['disabled'] };
  var rafPending = false, bootTimer = null, swapTimer = null, loadingTimer = null;

  function qsFirst(selectors, root) {
    root = root || document;
    for (var i = 0; i < selectors.length; i++) {
      var el = root.querySelector(selectors[i]);
      if (el) return el;
    }
    return null;
  }

  function isProductPage() {
    var path = location.pathname.replace(/\/$/, '');
    return !CONFIG.onlyOnProductPages || path.indexOf('/products/') !== -1 || isGfWafflePage();
  }

  function isGfWafflePage() {
    return /\/pages\/gf-waffle$/.test(location.pathname.replace(/\/$/, ''));
  }

  // Mobile-only gate. matchMedia so it tracks orientation changes and resizes, not just load.
  var mobileMQ = window.matchMedia
    ? window.matchMedia('(max-width: ' + CONFIG.mobileMaxWidth + 'px)')
    : null;

  function isMobileViewport() {
    return mobileMQ ? mobileMQ.matches : window.innerWidth <= CONFIG.mobileMaxWidth;
  }

  // The GF waffle lander deliberately uses the proven PDP sticky ATC at every
  // preview width. Product pages retain the original mobile-only behaviour.
  function isEligibleViewport() {
    return isGfWafflePage() || isMobileViewport();
  }

  function findATC() {
    var el = qsFirst(CONFIG.atcSelectors);
    if (el) return el;
    var nodes = Array.prototype.slice.call(document.querySelectorAll('button, input[type="submit"]'));
    var matches = nodes.filter(function (b) {
      return CONFIG.atcTextMatch.test((b.textContent || b.value || '').trim());
    });
    for (var i = 0; i < matches.length; i++) {
      if (matches[i].closest && matches[i].closest('form[action*="/cart/add"]')) return matches[i];
    }
    return matches[0] || null;
  }

  function injectCSS() {
    if (document.getElementById('tpp-sticky-atc-css')) return;
    var G = CONFIG.glass;
    var css = '' +
      '.tpp-sticky-atc{position:fixed;left:0;right:0;bottom:0;z-index:' + CONFIG.zIndex + ';' +
        'display:flex;justify-content:center;padding:12px 16px;' +
        'padding-bottom:calc(12px + env(safe-area-inset-bottom,0px));' +
        'background:rgba(' + G.tint + ',' + G.fallbackOpacity + ');' +
        'border-top:' + G.border + ';box-shadow:' + G.shadow + ';' +
        'transform:translateY(120%);transition:transform .28s cubic-bezier(.22,.61,.36,1);' +
        'will-change:transform;font-family:inherit;}' +
      '@supports ((backdrop-filter:blur(2px)) or (-webkit-backdrop-filter:blur(2px))){' +
        '.tpp-sticky-atc{background:rgba(' + G.tint + ',' + G.opacity + ');' +
        '-webkit-backdrop-filter:blur(' + G.blur + ') saturate(' + G.saturate + ');' +
        'backdrop-filter:blur(' + G.blur + ') saturate(' + G.saturate + ');}}' +
      '.tpp-sticky-atc.is-visible{transform:translateY(0);}' +
      '.tpp-sticky-atc__inner{width:100%;max-width:680px;display:flex;flex-direction:column;gap:10px;}' +
      '.tpp-sticky-atc__usps{display:flex;align-items:center;justify-content:space-between;gap:12px;}' +
      '.tpp-sticky-atc__usp{display:flex;align-items:center;gap:7px;white-space:nowrap;' +
        'font-size:13px;font-weight:600;line-height:1.2;color:' + CONFIG.uspColor + ';}' +
      '.tpp-sticky-atc__usp svg{flex:0 0 auto;width:20px;height:20px;}' +
      '.tpp-sticky-atc__btn{position:relative;width:100%;min-height:52px;padding:0 22px;border:0;cursor:pointer;' +
        'text-align:center;border-radius:16px;font-weight:700;font-size:16px;line-height:52px;' +
        'background:#692D01;color:#FCC9BD;transition:filter .15s ease, opacity .15s ease;}' +
      '.tpp-sticky-atc__btn:hover{filter:brightness(1.08);}' +
      '.tpp-sticky-atc__btn:active{filter:brightness(.92);}' +
      '.tpp-sticky-atc__btn[disabled]{opacity:.5;cursor:not-allowed;}' +
      '.tpp-sticky-atc__btn-label{display:inline-flex;align-items:center;justify-content:center;' +
        'gap:10px;transition:opacity .12s ease;}' +
      '.tpp-sticky-atc__bullet{opacity:.85;}' +
      '.tpp-sticky-atc__pill{display:inline-flex;align-items:center;gap:8px;' +
        'padding:3px 14px;border-radius:999px;background:#542500;line-height:1.3;}' +
      '.tpp-sticky-atc__compare-pill{position:absolute;top:0;left:50%;transform:translate(-50%,-50%);' +
        'display:inline-flex;align-items:center;gap:6px;width:max-content;max-width:calc(100% - 32px);' +
        'padding:4px 12px;border:1px solid #7EAFD3;border-radius:999px;background:#FFF;' +
        'color:#7EAFD3;font-size:12px;font-weight:700;line-height:1;letter-spacing:0px;' +
        'white-space:nowrap;z-index:2;}' +
      '.tpp-sticky-atc__compare-pill [data-pdp-atc-save]{text-decoration:none;}' +
      '.tpp-sticky-atc__was{color:#7EAFD3 !important;font:inherit;letter-spacing:0px !important;' +
        'text-decoration:line-through !important;' +
        'text-decoration-color:#7EAFD3 !important;text-decoration-thickness:2px;' +
        '-webkit-text-decoration:line-through #7EAFD3 !important;opacity:1;}' +
      '.tpp-sticky-atc__pill > .tpp-sticky-atc__was{color:#FCC9BD !important;' +
        'text-decoration-color:#FCC9BD !important;' +
        '-webkit-text-decoration:line-through #FCC9BD !important;}' +
      '.tpp-sticky-atc__compare-pill--pdp{position:static;transform:none;display:inline-flex;' +
        'gap:5px;max-width:none;padding:0;border:0;background:transparent;color:#FCC9BD;' +
        'font:inherit;line-height:inherit;letter-spacing:0px;}' +
      '.tpp-sticky-atc__compare-pill--pdp [data-pdp-atc-save],' +
      '.tpp-sticky-atc__compare-pill--pdp .tpp-sticky-atc__was{color:#FCC9BD !important;}' +
      '.tpp-sticky-atc__compare-pill--pdp .tpp-sticky-atc__was{' +
        'text-decoration-color:#FCC9BD !important;' +
        '-webkit-text-decoration:line-through #FCC9BD !important;}' +
      '.tpp-sticky-atc__pill .money{white-space:nowrap;}' +
      '@media (max-width:380px){.tpp-sticky-atc__usp{font-size:11.5px;gap:6px;}' +
        '.tpp-sticky-atc__usp svg{width:17px;height:17px;}' +
        '.tpp-sticky-atc__btn-label{gap:8px;}.tpp-sticky-atc__pill{padding:3px 11px;gap:6px;}}' +
      '.tpp-sticky-atc__btn.is-loading{cursor:wait;opacity:1;}' +
      '.tpp-sticky-atc__btn.is-loading .tpp-sticky-atc__btn-label{opacity:0;}' +
      '.tpp-sticky-atc__spinner{position:absolute;top:50%;left:50%;width:20px;height:20px;' +
        'margin:-10px 0 0 -10px;border-radius:50%;border:2.5px solid rgba(252,201,189,.35);' +
        'border-top-color:#FCC9BD;opacity:0;pointer-events:none;}' +
      '.tpp-sticky-atc__btn.is-loading .tpp-sticky-atc__spinner{opacity:1;' +
        'animation:tpp-spin .6s linear infinite;}' +
      '@keyframes tpp-spin{to{transform:rotate(360deg);}}' +
      '@media (max-width:380px){.tpp-sticky-atc__usp{font-size:11.5px;gap:6px;}' +
        '.tpp-sticky-atc__usp svg{width:17px;height:17px;}}' +
      '@media (min-width:768px){.tpp-sticky-atc{padding:14px 24px;}' +
        '.tpp-sticky-atc__btn{font-size:17px;}}' +
      '@media (prefers-reduced-motion:reduce){.tpp-sticky-atc{transition:none;}}' +
      // Mobile-only backstop: even if the bar is already in the DOM when the viewport
      // crosses the breakpoint, CSS hides it immediately without waiting for JS.
      '@media (min-width:' + (CONFIG.mobileMaxWidth + 1) + 'px){' +
        '.tpp-sticky-atc:not(.tpp-sticky-atc--gf-waffle){display:none !important;}}';
    var style = document.createElement('style');
    style.id = 'tpp-sticky-atc-css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  function copyButtonStyle(src, dest) {
    if (!src) return;
    var cs = getComputedStyle(src);
    // Colour is set explicitly (brand peach/brown); we copy only shape + type.
    ['fontFamily', 'fontWeight', 'letterSpacing', 'textTransform',
     'borderTopLeftRadius', 'borderTopRightRadius',
     'borderBottomLeftRadius', 'borderBottomRightRadius'].forEach(function (p) {
      try { if (cs[p]) dest.style[p] = cs[p]; } catch (e) {}
    });
    var fs = parseFloat(cs.fontSize) || 15;
    dest.style.fontSize = Math.min(fs, 16) + 'px';
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function parseDisplayedMoney(value) {
    var cleaned = String(value || '').replace(/[^0-9.,-]/g, '');
    if (!cleaned) return NaN;
    if (cleaned.indexOf(',') !== -1 && cleaned.indexOf('.') === -1) cleaned = cleaned.replace(',', '.');
    else cleaned = cleaned.replace(/,/g, '');
    return parseFloat(cleaned);
  }

  // syncNow() is the MutationObserver callback for the real ATC, so anything we
  // write back into that subtree queues another mutation record, which calls
  // syncNow() again. Pausing the observer around our own writes breaks that loop.
  function withObserverPaused(fn) {
    var mo = state.mo;
    if (mo) mo.disconnect();
    try { fn(); }
    finally {
      if (mo && state.realATC && document.contains(state.realATC)) mo.observe(state.realATC, MO_OPTIONS);
    }
  }

  // Ensure the GF waffle lander's compare-at price has a matching SAVE percentage.
  // That lander ships its own editor-driven pill in Liquid, so the build-a-wrapper
  // path below is a fallback for markup that arrives without one. It is gated to
  // that lander on purpose: product sections render their own button markup, and
  // restructuring it there both breaks the theme's `.pdp-atc-btn > [...]` child
  // selectors and (before this guard) spun the observer loop described above.
  function ensureSaveLabel(atc) {
    if (!atc) return;
    var compare = atc.querySelector('[data-pdp-atc-compare]');
    var current = atc.querySelector('[data-pdp-atc-price]');
    if (!compare || !current) return;

    var wrapper = compare.closest('[data-pdp-atc-compare-pill]');
    if (!wrapper && !isGfWafflePage()) return;
    var generated = !!(wrapper && wrapper.hasAttribute('data-tpp-generated-save-pill'));

    var compareValue = parseDisplayedMoney(compare.textContent);
    var currentValue = parseDisplayedMoney(current.textContent);
    var hasSaving = isFinite(compareValue) && isFinite(currentValue) && compareValue > currentValue;

    if (!hasSaving) {
      if (generated && !wrapper.hidden) withObserverPaused(function () { wrapper.hidden = true; });
      return;
    }

    if (!wrapper) {
      withObserverPaused(function () {
        wrapper = document.createElement('span');
        wrapper.setAttribute('data-pdp-atc-compare-pill', '');
        wrapper.setAttribute('data-tpp-generated-save-pill', '');
        compare.parentNode.insertBefore(wrapper, compare);
        var save = document.createElement('span');
        save.setAttribute('data-pdp-atc-save', '');
        wrapper.appendChild(save);
        wrapper.appendChild(compare);
      });
      generated = true;
    }

    // Only write what actually changed — an unconditional textContent assignment
    // replaces the text node every pass and re-arms the observer.
    var saveLabel = generated ? wrapper.querySelector('[data-pdp-atc-save]') : null;
    var percent = Math.round(((compareValue - currentValue) / compareValue) * 100);
    var text = percent > 0 ? 'SAVE ' + percent + '%' : '';
    var needsText = !!(saveLabel && text && saveLabel.textContent !== text);
    if (!wrapper.hidden && !needsText) return;

    withObserverPaused(function () {
      wrapper.hidden = false;
      if (needsText) saveLabel.textContent = text;
    });
  }

  // Read the struck compare-at price from the SELECTED purchase-option card only,
  // so the Rebuy upsell compare-at prices are never picked up. Returns '' when the
  // current selection has no saving (e.g. one-time purchase).
  // (Retained as a fallback; this theme renders the compare-at inside the button,
  //  which syncNow() now clones directly, so this is not used in the common path.)
  function getCompareAt() {
    try {
      var checked = document.querySelector(CONFIG.compareAtOption + ' input:checked');
      var card = checked && checked.closest ? checked.closest(CONFIG.compareAtOption) : null;
      if (!card) return '';
      var s = card.querySelector(CONFIG.compareAtStruck);
      if (!s) return '';
      var t = (s.textContent || '').replace(/\s+/g, ' ').trim();
      return /\d/.test(t) ? t : '';
    } catch (e) { return ''; }
  }

  function syncNow() {
    if (!state.btn || !state.btnLabel || !state.realATC || !document.contains(state.realATC)) return;
    ensureSaveLabel(state.realATC);
    var label = (state.realATC.textContent || '').replace(/\s+/g, ' ').trim() || 'Add to cart';
    state.btn.setAttribute('aria-label', label);

    // This theme builds the price (incl. a struck <s> compare-at) right inside the
    // real button. We clone its children, then split them into the text label
    // ("ADD TO CART") and the price node(s), so we can wrap the price in a pill.
    var clone = state.realATC.cloneNode(true);
    clone.querySelectorAll('svg, .tpp-sticky-atc__spinner, [aria-hidden="true"]').forEach(function (n) { n.remove(); });

    var priceRx = /[$£€]\s?\d/;
    var textParts = [], priceNodes = [];
    Array.prototype.forEach.call(clone.childNodes, function (n) {
      var txt = (n.textContent || '').replace(/\s+/g, ' ').trim();
      if (!txt) return;
      if (priceRx.test(txt)) priceNodes.push(n);          // a price chunk (incl. <s> compare-at)
      else if (txt !== '•' && txt !== '·') textParts.push(txt);  // drop any stray bullet; we re-add our own
    });

    if (priceNodes.length) {
      state.btnLabel.innerHTML = '';
      var lead = document.createElement('span');
      lead.className = 'tpp-sticky-atc__lead';
      lead.textContent = (textParts.join(' ') || 'Add to cart');
      state.btnLabel.appendChild(lead);

      var bullet = document.createElement('span');
      bullet.className = 'tpp-sticky-atc__bullet';
      bullet.textContent = '•';
      state.btnLabel.appendChild(bullet);

      var pill = document.createElement('span');
      pill.className = 'tpp-sticky-atc__pill';
      priceNodes.forEach(function (n) { pill.appendChild(n); });   // both prices share ONE pill
      pill.querySelectorAll('[data-pdp-atc-compare-pill]').forEach(function (n) {
        n.classList.add('tpp-sticky-atc__compare-pill');
        if (n.hasAttribute('data-tpp-generated-save-pill')) n.classList.add('tpp-sticky-atc__compare-pill--pdp');
      });
      pill.querySelectorAll('s, del').forEach(function (n) { n.classList.add('tpp-sticky-atc__was'); });
      state.btnLabel.appendChild(pill);
    } else {
      state.btnLabel.textContent = label;
    }

    if (!state.loading) {   // don't fight the spinner's disabled state mid-request
      state.btn.disabled = state.realATC.disabled || /sold\s*out/i.test(label);
    }
  }

  function setLoading(on) {
    if (!state.btn) return;
    state.loading = on;
    state.btn.classList.toggle('is-loading', on);
    state.btn.setAttribute('aria-busy', on ? 'true' : 'false');
    state.btn.disabled = on ? true : (state.realATC ? !!state.realATC.disabled : false);
    clearTimeout(loadingTimer);
    if (on) loadingTimer = setTimeout(endLoading, 6000);   // safety net — never hang
  }

  function endLoading() {
    clearTimeout(loadingTimer);
    if (!state.loading) return;
    setLoading(false);
    syncNow();
  }

  // Called when a cart request settles; stop the spinner shortly after so the
  // cart drawer has a moment to render.
  function onCartRequestSettled() {
    if (state.loading) setTimeout(endLoading, 300);
  }

  function updateVisibility() {
    if (!state.bar || !state.realATC) return;
    var attached = document.contains(state.realATC);
    var r = attached ? state.realATC.getBoundingClientRect() : null;
    // PDPs keep the proven trigger (the full button has left the viewport). On
    // the GF waffle lander, reveal as soon as the main button starts crossing
    // the top edge so the sticky control is much harder to miss.
    var triggerReached = r && (isGfWafflePage() ? r.top <= 0 : r.bottom <= 0);
    var show = !!(attached && triggerReached && isProductPage() && isEligibleViewport());
    state.bar.classList.toggle('is-visible', show);
  }

  function teardown() {
    if (state.mo) { state.mo.disconnect(); state.mo = null; }
    if (state.bar && state.bar.parentNode) state.bar.parentNode.removeChild(state.bar);
    state.bar = state.btn = state.realATC = null;
  }

  function mount() {
    var atc = findATC();
    if (!atc) return false;
    // Already wired to this exact, still-attached button → just refresh.
    if (state.bar && state.realATC === atc && document.contains(atc)) {
      syncNow(); updateVisibility(); return true;
    }
    teardown();
    injectCSS();
    state.realATC = atc;

    var bar = document.createElement('div');
    bar.className = 'tpp-sticky-atc' + (isGfWafflePage() ? ' tpp-sticky-atc--gf-waffle' : '');
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');

    var inner = document.createElement('div');
    inner.className = 'tpp-sticky-atc__inner';

    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'tpp-sticky-atc__btn';
    var btnLabel = document.createElement('span');
    btnLabel.className = 'tpp-sticky-atc__btn-label';
    var spinner = document.createElement('span');
    spinner.className = 'tpp-sticky-atc__spinner';
    spinner.setAttribute('aria-hidden', 'true');
    btn.appendChild(btnLabel);
    btn.appendChild(spinner);
    inner.appendChild(btn);

    var usps = document.createElement('div');
    usps.className = 'tpp-sticky-atc__usps';
    (CONFIG.usps || []).forEach(function (u) {
      var item = document.createElement('span');
      item.className = 'tpp-sticky-atc__usp';
      item.innerHTML = u.icon + '<span>' + u.label + '</span>';   // static, no user input
      usps.appendChild(item);
    });
    inner.appendChild(usps);

    bar.appendChild(inner);
    document.body.appendChild(bar);
    state.bar = bar; state.btn = btn; state.btnLabel = btnLabel;
    copyButtonStyle(atc, btn);
    syncNow();

    state.mo = new MutationObserver(syncNow);
    state.mo.observe(atc, MO_OPTIONS);

    btn.addEventListener('click', function () {
      if (state.loading || btn.disabled || !state.realATC) return;
      try { window.dataLayer && window.dataLayer.push({ event: 'tpp_sticky_atc_click' }); } catch (e) {}
      window.dispatchEvent(new CustomEvent('tpp:sticky_atc_click'));
      setLoading(true);
      state.realATC.click();   // preserves size + selling plan + quantity
    });

    updateVisibility();
    return true;
  }

  // Decide mount vs teardown for the current page; retry while late widgets load.
  function boot() {
    clearTimeout(bootTimer);
    ensureSaveLabel(findATC());
    if (!isProductPage() || !isEligibleViewport()) { teardown(); return; }
    var tries = 0;
    (function attempt() {
      if (state.bar && state.realATC && document.contains(state.realATC)) {
        syncNow(); updateVisibility(); return;
      }
      if (mount()) return;
      if (tries++ < 25) bootTimer = setTimeout(attempt, 400);   // ~10s of retries
    })();
  }

  /* ---- global listeners / patches (installed once) ----------------------- */
  function onScrollResize() {
    if (rafPending) return;
    rafPending = true;
    requestAnimationFrame(function () { rafPending = false; updateVisibility(); });
  }
  window.addEventListener('scroll', onScrollResize, { passive: true });
  window.addEventListener('resize', onScrollResize);

  // Crossing the mobile/desktop breakpoint tears the bar down or builds it back up.
  if (mobileMQ) {
    var onBreakpointChange = function () { boot(); };
    if (mobileMQ.addEventListener) mobileMQ.addEventListener('change', onBreakpointChange);
    else if (mobileMQ.addListener) mobileMQ.addListener(onBreakpointChange);   // Safari < 14
  }

  // Re-sync after the shopper changes size / frequency / variant.
  document.addEventListener('change', function () { setTimeout(syncNow, 120); }, true);

  // Watch cart requests so the spinner stops exactly when the add settles.
  (function patchNetwork() {
    var rx = /\/cart\/(add|change|update)/i;
    try {
      var origFetch = window.fetch;
      if (typeof origFetch === 'function') {
        window.fetch = function (input) {
          var url = (typeof input === 'string') ? input : (input && input.url) || '';
          var p = origFetch.apply(this, arguments);
          if (rx.test(url) && p && typeof p.then === 'function') p.then(onCartRequestSettled, onCartRequestSettled);
          return p;
        };
      }
    } catch (e) {}
    try {
      var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) { this.__tppUrl = url; return XO.apply(this, arguments); };
      XMLHttpRequest.prototype.send = function () {
        try { if (rx.test(this.__tppUrl || '')) this.addEventListener('loadend', onCartRequestSettled); } catch (e) {}
        return XS.apply(this, arguments);
      };
    } catch (e) {}
  })();

  // Soft (AJAX / SPA) navigation: flavour switch, quick-swap, etc.
  ['pushState', 'replaceState'].forEach(function (m) {
    var orig = history[m];
    if (typeof orig === 'function') {
      history[m] = function () { var r = orig.apply(this, arguments); setTimeout(boot, 50); return r; };
    }
  });
  window.addEventListener('popstate', function () { setTimeout(boot, 50); });
  window.addEventListener('pageshow', boot);   // back/forward + bfcache restore

  // In-place content swaps that don't change the URL (product section replaced).
  var bodyMO = new MutationObserver(function () {
    if (swapTimer) return;
    swapTimer = setTimeout(function () { swapTimer = null; boot(); }, 250);
  });

  function start() {
    try { bodyMO.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    boot();
  }
  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start);
})();
